import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const baseDataForm: Form<Client> = {
  key: 'baseData',
  title: 'Telefonische Beratung',
  fields: [
    {
      key: 'consultantCode',
      label: 'Berater*in-/Therapeut*in-Code',
      fieldTypes: 'text',
    },
    {
      key: 'date',
      label: 'Datum',
      fieldTypes: 'date',
    },
    {
      key: 'caseId',
      label: 'Fall-Kennnummer',
      fieldTypes: 'text',
    },
    {
      key: 'phoneCallDetails',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      chart: {
        type: 'bar',
        heading: 'Art des Telefonates',
      },
      options: [
        {
          value: 'otherTelefonCall',
          label: 'sonstiges Telefonate',
        },
        {
          value: 'infoDispatch',
          label: 'Info-Versand',
        },
      ],
    },
  ],
};

export default baseDataForm;
